import { render, staticRenderFns } from "./adminManage.vue?vue&type=template&id=224dbb50&"
import script from "./adminManage.vue?vue&type=script&lang=js&"
export * from "./adminManage.vue?vue&type=script&lang=js&"
import style0 from "./adminManage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports